import { render, staticRenderFns } from "./Motivopermiso.vue?vue&type=template&id=45e25f7f&"
import script from "./Motivopermiso.vue?vue&type=script&lang=js&"
export * from "./Motivopermiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports